import { render, staticRenderFns } from "./noticeArea.vue?vue&type=template&id=65c0dabf&scoped=true"
import script from "./noticeArea.vue?vue&type=script&lang=js"
export * from "./noticeArea.vue?vue&type=script&lang=js"
import style0 from "./noticeArea.vue?vue&type=style&index=0&id=65c0dabf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c0dabf",
  null
  
)

export default component.exports